import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/lump-sum-vs-annuity',
  component: () => import('../../routes/LumpSumVsAnnuityCalculator.svelte'),
  card: {
    id: 'lump-sum-vs-annuity',
    title: 'Lump Sum vs. Annuity',
    description: 'Compare taking a lump sum today versus receiving annuity payments over time. See which option leaves you with more wealth at the end of the payment period.',
    icon: 'account_balance',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/lump-sum-vs-annuity',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Lump Sum vs. Annuity Calculator – Compare Your Payout Options',
    description: 'Free lump sum vs. annuity calculator to compare taking a one-time payout versus receiving annual annuity payments. See future values, present values, and year-by-year breakdowns to decide which option is better.',
  },
};

export default meta;
